"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormatPoints = void 0;
var _hooks = require("../hooks");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Returns props `value` formatted as the points (Loyalty and other points).
 * @see {@link useFormatPoints} for more information.
 *
 * @see {@link FormatPointsProps} for the available props.
 * @example
  // basic usage
  <FormatPoints value={1234.567} /> *
 */
const FormatPoints = ({
  children,
  value
}) => {
  const formattedValue = (0, _hooks.useFormatPoints)(value ?? children);

  // eslint-disable-next-line react/jsx-no-useless-fragment -- false positive
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: formattedValue
  });
};
exports.FormatPoints = FormatPoints;
